import type { SystemMessage } from '@xsai/shared-chat'

function message(prefix: string, suffix: string) {
  return {
    role: 'system',
    content: [prefix, suffix].join('\n\n'),
  } satisfies SystemMessage
}

export default message
